import React from 'react'
import { Box, DialogContent } from '@mui/material'
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { TextField } from 'src/Libs/inputs/react-hook-form'
import { Alert } from '@e3dc-react/shell/Elements/Alert'
import { useDialogActionsPositioned } from '../../../hooks'
import Actions from '@e3dc-react/shell/Elements/Dialog/ActionDialog/Actions'

interface AddEmcProps {
  error: string | null
  closeDialog: () => void
  addEmc: (name: string) => void
}

/**
 * Form to add an emc to the installation. Should be always disabled. Thought of as content inside a dialog.
 */
export const AddEmc: React.FC<AddEmcProps> = ({ error, closeDialog, addEmc }) => {
  const { t } = useCustomTranslation()

  const methods = useForm({ defaultValues: { emcName: 'EMC' } })
  const { handleSubmit } = methods

  const onSubmit: SubmitHandler<{ emcName: string }> = data => {
    addEmc(data.emcName)
    closeDialog()
  }

  return (
    <FormProvider {...methods}>
      <Box component={'form'} display={'contents'} onSubmit={handleSubmit(onSubmit)}>
        <DialogContent dividers sx={{ px: 0, py: 4 }}>
          {error ? (
            <Box>
              <Alert severity="warning" sx={{ marginBottom: 2 }} text={error} />
              <TextField name="emcName" label={t('common.name')} fullWidth disabled />
            </Box>
          ) : (
            <TextField name="emcName" label={t('common.name')} fullWidth disabled />
          )}
        </DialogContent>
        <Actions actions={useDialogActionsPositioned(t('installation.productEditor.edit.emc'), handleSubmit(onSubmit), !!error, closeDialog)} />
      </Box>
    </FormProvider>
  )
}
